export const nameof = <T>(name: Extract<keyof T, string>): string => name;

export function getValueByString<T>(object: any, path: string): T {
  const parts = path.split(".");
  return parts.reduce((result: any, key) => {
    if (result !== undefined && result[key]) {
      return result[key];
    }

    return undefined;
  }, object) as any;
}
